import React from 'react';

export function InputLogin({type = 'text', error, placeholder = '', name, title, value, disabled, onChange}) {

  return <div className="auth__group">
    <p className="auth__help help">{title}</p>
    <input type={type}
           name={name}
           className={"auth__input input" + (error ? " input--error" : "")}
           placeholder={placeholder}
           value={value}
           disabled={disabled}
           onChange={onChange}/>
  </div>;
}
